// extracted by mini-css-extract-plugin
module.exports = {"calendar-wrapper":"_3zfP7","calendarWrapper":"_3zfP7","before-calendar":"WfQ80","beforeCalendar":"WfQ80","calendar":"_2rA3x"};